import React from "react";
import styled from "styled-components";

interface Props {
  children?: React.ReactNode[];
}

export const Div = styled.div`
  > *:first-child {
    margin-top: 0;
  }
  > * {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  > *:last-child {
    margin-bottom: 0;
  }
`;

export const GroupedComponents: React.FC<Props> = props => <Div {...props} />;
